import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { deleteTypes } from '../constant'
import {
  checkItem,
  selectCheckeditem,
  selectDeleteType,
  uncheckItem,
} from './store/slice'

const CheckboxItem = ({ rowId }) => {
  const dispatch = useDispatch()

  const deleteType = useSelector(selectDeleteType)
  const value = useSelector(selectCheckeditem(rowId))

  const isDeleteIn = deleteType === deleteTypes.IN
  const isChecked = isDeleteIn ? value : !value

  const onChange = (valChecked) => {
    const actionTrue = isDeleteIn ? checkItem : uncheckItem
    const actionFalse = isDeleteIn ? uncheckItem : checkItem

    if (valChecked) {
      dispatch(actionTrue(rowId))
    } else {
      dispatch(actionFalse(rowId))
    }
  }

  return <Checkbox checked={isChecked} onChange={onChange} />
}

CheckboxItem.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default CheckboxItem
